import { makeAutoObservable } from 'mobx'
import { BuyCreditsModalStore } from 'entities/Billing/ui/BuyCreditsModal'
import type { UsersStore } from 'entities/Users'
import type { SubscriptionStore } from 'entities/Subscription'
import type { OrganizationStore } from 'entities/Organization'
import type { BillingStore } from 'entities/Billing'
import type { FeatureFlagsStore } from 'entities/FeatureFlags'
import type { AuthStore } from 'entities/Auth'
import { ReminderTenDLCStore } from '../ui/TenDLC'
import { ReminderCreditsStore } from '../ui/Credits'
import { ReminderTrialCreditsStore } from '../ui/TrialCredits'

export class RemindersStore {
  tenDlcStore: ReminderTenDLCStore
  creditsStore: ReminderCreditsStore
  trialCreditsStore: ReminderTrialCreditsStore
  buyCreditsModalStore: BuyCreditsModalStore

  constructor(
    private _usersStore: UsersStore,
    private _subscriptionStore: SubscriptionStore,
    private _organizationStore: OrganizationStore,
    private _billingStore: BillingStore,
    private _featureFlagsStore: FeatureFlagsStore,
    private _authStore: AuthStore
  ) {
    this.tenDlcStore = new ReminderTenDLCStore(this._usersStore, this._authStore)
    this.creditsStore = new ReminderCreditsStore(
      this._subscriptionStore,
      this._organizationStore,
      this._billingStore,
      this._featureFlagsStore,
      this._usersStore
    )
    this.trialCreditsStore = new ReminderTrialCreditsStore(
      this._subscriptionStore,
      this._organizationStore
    )
    this.buyCreditsModalStore = new BuyCreditsModalStore(
      this._subscriptionStore,
      this._organizationStore,
      this._billingStore
    )

    makeAutoObservable(this)
  }

  init = () => {
    this.tenDlcStore.init()
    this.creditsStore.init()
    this.trialCreditsStore.init()
  }
}
